const onlyNumbers = (value) => value?.replace(/\D/g, '')

export default onlyNumbers
